import { isEmail } from './isEmail';
/**
 *Function to format the changed data
 * @param {array} changedText
 * @returns {string} formatted string of changed data
 */

const formatChangedData = (changedData) => {
  const verb = changedData.length > 1 ? 'have' : 'has'; // Correct grammar

  return `Your ${changedData.join(', ')} ${verb} been successfully updated`;
};

/**
 * The function to create a toast message
 * that lists all the fields that have been updated for user
 * @param {object} data - initial account data
 * @param {object} userData - account data from the form
 * @param {object} newData - updated account data from the server
 * @returns {string} message - the message to be displayed in the toast
 * @returns {string} toastStatus - the status of the toast (success, info, error)
 */

export const handleToastMessages = (data, userData, responseData) => {
  const changedData = [];
  let message = '';
  let toastStatus = 'success';

  // Check if server returned a message (e.g., for email verification)
  if (responseData.message) {
    return {
      message: responseData.message,
      toastStatus: 'info',
    };
  }

  // Extract user data from response
  const newData = responseData.user || responseData;

  // Legacy support: if email is changed with Devise (old implementation)
  if (!!newData.unconfirmed_email && newData.email !== newData.unconfirmed_email) {
    message = 'Check your email for a link to confirm your updated email address.';
    toastStatus = 'info';

    return { message, toastStatus };
  }

  const oldFirst = data?.firstName?.toLowerCase?.();
  const newFirst = newData?.name_first?.toLowerCase?.();
  if (oldFirst && newFirst && oldFirst !== newFirst) {
    changedData.push('first name');
  }

  const oldLast = data?.lastName?.toLowerCase?.();
  const newLast = newData?.name_last?.toLowerCase?.();
  if (oldLast && newLast && oldLast !== newLast) {
    changedData.push('last name');
  }
  // we cannot check if the password is changed with response from the server
  // because it does not return the password field, so we need to check it with frontend data
  if (!!userData.password && userData.password === userData?.password_confirmation) {
    changedData.push('password');
  }

  if (changedData.length > 0) {
    message = formatChangedData(changedData);
  }

  return { message, toastStatus };
};

/**
 *function to create an object of errors
 *for empty input fields
 *the error messages are the same as in the backend validation
 * @param {object} data - form data
 * @returns {object} with errors
 */

export const handleErrorMessages = (data) => {
  const errors = {};
  if (data.name_first === '') {
    errors.name_first = "First name can't be blank";
  }
  if (data.name_last === '') {
    errors.name_last = "Last name can't be blank";
  }
  if (data.email === '') {
    errors.email = "Email can't be blank";
  }
  if (data.email !== '' && !isEmail(data.email)) {
    errors.email = 'Please enter a valid email address';
  }
  if (data.current_password === '') {
    errors.current_password = 'Required';
  }

  if (data.password && data.password !== data.password_confirmation) {
    errors.password = "Password confirmation doesn't match new password";
  }
  return errors;
};
